import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents, palette }: ComposedTheme) => ({
  block: {
    flex: '1',
  },
  btnCtrl: {
    '& svg': {
      fill: formComponents.numberInput.buttonColor,
    },
    '&$dark': {
      '& svg': {
        fill: formComponents.numberInput.buttonColorDark,
      },
      '&:disabled': {
        backgroundColor: formComponents.numberInput.buttonBackGroundColorDark,
        opacity: '40%',
      },
      '&:hover, &:focus': {
        backgroundColor: formComponents.input.darkFocusColor,
        outlineColor: formComponents.input.darkFocusColor,
      },
      backgroundColor: formComponents.input.dark.backgroundColor,
      borderColor: formComponents.numberInput.buttonColorDark,
      color: formComponents.dark.color,
    },
    '&$error': {
      borderColor: palette.form.error,
      '&$dark': {
        borderColor: formComponents.dark.error.color,
      },
    },
    '&$warning$error': {
      borderColor: formComponents.warning.borderColor,
      '&$dark': {
        borderColor: formComponents.dark.warning.borderColor,
      },
    },
    '&:disabled': {
      backgroundColor: palette.form.border,
      color: formComponents.input.color,
      cursor: 'default',
      opacity: '40%',
    },
    '&:hover, &:focus': {
      backgroundColor: palette.highlightBackground,
    },
    backgroundColor: formComponents.input.backgroundColor,
    border: `1px solid ${formComponents.numberInput.buttonColor}`,
    borderRadius: [0, 2, 2, 0],
    color: palette.primary.normal,
    cursor: 'pointer',
    display: 'inline-block',
    width: 35,
  },
  btnMinus: {
    borderRadius: [2, 0, 0, 2],
    marginRight: -1,
    paddingTop: 4,
    zIndex: 1,
  },
  btnPlus: {
    borderRadius: [0, 2, 2, 0],
    paddingTop: 4,
  },
  dark: {},
  error: {},
  number: {
    '& input': {
      ...formComponents.numberInput,
      '-moz-appearance': 'textfield',
      borderRightColor: 'transparent',
    },
    '& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    display: 'flex',
    marginBottom: 0,
  },
  root: {
    display: 'block',
    marginBottom: formComponents.container.marginBottom,
  },
  inline: {
    borderRadius: 0,
    display: 'flex',
  },
  inlineNumber: {
    flex: 1,
  },
  warning: {},
});

export default createUseStyles(styles);
